module.exports = __webpack_public_path__ + "static/media/didemoon-bazdidemoon.3799f872.svg";